<template>
	<div class="home_wrap">
		<div class="red_top_bg">

			<!-- <div class="top_title">{{app.title}}</div> -->
			<div class="top_title">{{ $t('index.title') }}</div>

			<!-- <div class="msg" @click="$router.push('/notice')">
				<img src="../images/index/msg.png">
			</div> -->
			<!-- 隐藏原有的语言选择器 -->
			<div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/' + lang + '.png')">
			</div>

		<!-- 新的语言选择下拉框 -->
		<!-- <div class="language_selector">
			<select v-model="displayLang" @change="onLanguageChange" class="language_select">
				<option value="zh_hk">繁體中文</option>
				<option value="en">English</option>
				<option value="ja">日本語</option>
				<option value="ko">한국어</option>
			</select>
			</div> -->
		</div>
		<div class="content">
			<div class="langbar">
				<!-- 隐藏搜索框 -->
				<!--
		    <div class="search_box" @click="$router.push('/search')">
		        <i class="fdj"></i>
		        <input type="text" readonly :placeholder="$t('index.search')" class="search_inp">
		        <div class="clear_inp"></div>
		    </div>
			-->

				<!-- 消息通知横幅 -->
				<div class="message_banner">
					<img src="../../../src/assets/images/home/notice.png" alt="">
					<div class="message_scroll">
						<span class="message_text">{{ cleanPopupContent }}</span>
					</div>
				</div>
			</div>
			<van-swipe :autoplay="2500" class="swiper-container" @change="onChange">
				<van-swipe-item v-for="(image, index) in data.banner" :key="index">
					<router-link :to="image.url">
						<img :src="image[lang]">
					</router-link>
				</van-swipe-item>
				<div ref="dian" slot="indicator" class="custom-indicator">
					<div v-for="(img, x) in data.banner" :key="x" :class="x === 0 ? 'selected' : ''" />
				</div>
			</van-swipe>
			<div v-show="loading" class="work_box">
				<div class="item" @click="$router.push('/login')">
					<div class="item_img"><img src="../../../src/assets/images/home/login.png" alt=""></div>
					<p class="item_title">{{ $t('index.sign') }}</p>
				</div>
				<div class="item" @click="$router.push('/register')">
					<div class="item_img"><img src="../../../src/assets/images/home/register.png" alt=""></div>
					<p class="item_title">{{ $t('index.invite') }}</p>
				</div>
				<!-- <div class="item" @click="$router.push('/kefu')">
					<div class="item_img"><img src="../../../src/assets/images/home/kefu.png" alt=""></div>
					<p class="item_title">{{ $t('index.recharge') }}</p>
				</div> -->
				<div class="item" @click="$router.push('/deposit')">
					<div class="item_img"><img src="../../../src/assets/images/home/cun.png" alt=""></div>
					<p class="item_title">{{ $t('index.withdraw') }}</p>
				</div>
				<div class="item" @click="$router.push('/withdraw')">
					<div class="item_img"><img src="../../../src/assets/images/home/qu.png" alt=""></div>
					<p class="item_title">{{ $t('index.withdraw_cash') }}</p>
				</div>

				<!-- <div class="item" v-if="shouldShowLoanButton" @click="$router.push('/loan')">
					<div class="item_img"><img src="../images/about/icon0.png" alt=""></div>
					<p class="item_title">{{ $t('index.loan') }}</p>
				</div> -->
			<!-- 
			<div class="item" @click="$router.push('/myTeam')">
				<div class="item_img"><img src="../images/about/icon8.png" alt=""></div>
				<p class="item_title">{{ $t('index.invite') }}</p>
			</div>
			<div class="item" @click="$router.push('/invest')">
				<div class="item_img"><img src="../images/about/icon9.png" alt=""></div>
				<p class="item_title">{{ $t('index.recharge') }}</p>
			</div>
			<div class="item" @click="$router.push('/cash')">
				<div class="item_img"><img src="../images/about/icon6.png" alt=""></div>
				<p class="item_title">{{ $t('index.withdraw') }}</p>
			</div>

			<template v-if="!isapp">
				<div class="item" @click="download">
					<div class="item_img"><img src="../images/about/icon12.png" alt=""></div>
					<p class="item_title">APP</p>
				</div>
			</template>
<template v-else>
				<div class="item" @click="$router.push('/moneybag')">
					<div class="item_img"><img src="../images/about/icon2.png" alt=""></div>
					<p class="item_title">{{ $t('user.myWallet') }}</p>
				</div>
			</template>

<template v-if="!islogin">
				<div class="item" @click="$router.push('/register')">
					<div class="item_img"><img src="../images/about/icon7.png" alt=""></div>
					<p class="item_title">{{ $t('register.register') }}</p>
				</div>
			</template>
<template v-else>
				<div class="item" @click="$router.push('/about')">
					<div class="item_img"><img src="../images/index/help.png" alt=""></div>
					<p class="item_title">{{ $t('index.aboutUs') }}</p>
				</div>
			</template>

<div class="item" @click="$router.push('/about/10')">
	<div class="item_img"><img src="../images/about/icon4.png" alt=""></div>
	<p class="item_title">{{ $t('index.license') }}</p>
</div>
<div class="item" @click="$router.push('/kefu')">
	<div class="item_img"><img src="../images/about/icon11.png" alt=""></div>
	<p class="item_title">{{ $t('user.onlineService') }}</p>
</div> -->
			</div>

			<!-- 稳健项目投资产品展示 -->
			<div class="stable_projects">
				<div class="projects_header">
					<div class="blue_bar"></div>
					<h3 class="projects_title">{{ $t('index.StableProject') }}</h3>
				</div>

				<div class="project_cards">
					<div class="project_card" v-for="(project, index) in projectList" :key="project.id">
						<div class="card_image" @click="goToProject(project)">
							<img :src="project.img" :alt="project.name">
						</div>
						<div class="card_content">
							<h4 class="project_name" @click="goToProject(project)">{{ project.name }}</h4>
							<div class="rates">
								<span class="rate" v-for="(rate, rateIndex) in project.rates.slice(0, 3)" :key="rateIndex">
									{{ rate }}
								</span>
							</div>
							<p class="company_name">{{ project.company }}</p>
						</div>
					</div>
				</div>
			</div>

			<!-- <div v-show="!loading" class="work_box query">
				<div v-for="i in 10" class="item">
					<div class="item_img" />
					<p class="item_title" />
				</div>
			</div> -->

			<!-- <div class="ads_box_1">
			<div class="ads_img" v-for="ad in data.ad1">
				<router-link :to="ad.url">
					<img :src="ad[lang]" alt="">
				</router-link>
			</div>
		</div>
		<div v-if="data.item1.show" class="items_1">
			<h5 class="items_tit">
				{{ $t('item.tab1') }}
				<span class="tit_tip">{{ $t('index.novice_tip') }}</span>
				<router-link to="/item?type=1">
					<span class="tit_more">{{ $t('index.more') }}</span>
				</router-link>
			</h5>
			<div v-for="i in data.item1.list" :key="i.id" class="item">
				<div class="item_tit" @click="$router.push('/item/' + i.id)" :style="showcover ? 'margin-top: 0px' : ''">
					<div v-if="showcover"
						:style="'background-image:url(' + i.img + ');background-size:cover;width:100%;height:150px;margin-top:0px;'">
					</div>
					<p>
						{{ i[lang] }}
					</p>
				</div>
				<div class="item_rate" @click="$router.push('/item/' + i.id)">
					<p>{{ i.rate }}%</p>
				</div>
				<div class="item_desc" @click="$router.push('/item/' + i.id)">
					<p>{{ $t('utils.cycle') }}:{{ i.day }}{{ $t('utils.' + i.unit) }}</p>
					<p>{{ $t('utils.startingAmount') }}:{{ utils_moneyMark() }}{{ i.min }}</p>
				</div>
				<div class="item_btn">
					<button v-if="i.percent < 100" type="button" @click="buy(i)">{{ $t('utils.invest') }}</button>
					<button v-if="i.percent >= 100" class="item_btn_over"
						type="button">{{ $t('utils.investOver') }}</button>
				</div>
			</div>
		</div>
		<div class="ads_box">
			<div class="ads_img" v-for="ad in data.ad2">
				<router-link :to="ad.url">
					<img :src="ad[lang]" alt="">
				</router-link>
			</div>
		</div>
		<div v-if="data.item2.show" class="items_2">
			<h5 class="items_tit">
				{{ $t('item.tab2') }}
				<span class="tit_tip">{{ $t('index.hot_tip') }}</span>
				<router-link to="/item?type=2">
					<span class="tit_more">{{ $t('index.more') }}</span>
				</router-link>
			</h5>
			<div v-for="i in data.item2.list" :key="i.id" class="item">
				<div class="item_rate">
					<p>{{ i.rate }}%</p>
					<p>{{ $t('utils.' + i.unit + 'Income') }}</p>
				</div>
				<div class="item_tit" @click="$router.push('/item/' + i.id)">
					<p>
						{{ i[lang] }}
					</p>
					<p>{{ i['desc_' + lang] }}</p>
				</div>
				<div class="item_btn">
					<button v-if="i.percent < 100" type="button" @click="buy(i)">{{ $t('utils.invest') }}</button>
					<button v-if="i.percent >= 100" class="item_btn_over"
						type="button">{{ $t('utils.investOver') }}</button>
				</div>
			</div>
		</div>
		<div class="ads_box">
			<div class="ads_img" v-for="ad in data.ad3">
				<router-link :to="ad.url">
					<img :src="ad[lang]" alt="">
				</router-link>
			</div>
		</div>
		<div v-if="data.item3.show" class="items_3">
			<div v-for="i in data.item3.list" :key="i.id" class="item">
				<div class="item_div1" @click="$router.push('/item/' + i.id)">
					<p>
						{{ i[lang] }}
					</p>
				</div>
				<div v-if="showcover" @click="$router.push('/item/' + i.id)"
					:style="'background-image:url(' + i.img + ');background-size:cover;width:100%;height:150px;margin-top:0px;'">
				</div>

				<div class="item_div2" @click="$router.push('/item/' + i.id)">
					<div class="item_rate">
						<p>{{ i.rate }}%</p>
						<p>{{ $t('utils.' + i.unit + 'Income') }}</p>
					</div>
					<div class="item_day">
						<p>{{ i.day }}{{ $t('utils.' + i.unit) }}</p>
						<p>{{ $t('utils.cycle') }}</p>
					</div>
					<div class="item_min">
						<p>{{ utils_moneyMark() }}{{ i.min }}</p>
						<p>{{ $t('utils.startingAmount') }}</p>
					</div>
				</div>
				<div class="item_div3">
					<span>{{ $t('utils.scale') }}:{{ utils_moneyMark() }}{{ i.total }}</span>
				</div>
				<div class="item_div4">
					<van-progress :percentage="i.percent" />
					<div class="item_btn">
						<button v-if="i.percent < 100" type="button" @click="buy(i)">{{ $t('utils.invest') }}</button>
						<button v-if="i.percent >= 100" class="item_btn_over"
							type="button">{{ $t('utils.investOver') }}</button>
					</div>
				</div>
			</div>
		</div>
		<van-dialog v-model="show_tz" show-cancel-button @confirm="confirm" :confirmButtonText="$t('utils.confirm')"
			:cancelButtonText="$t('utils.cancel')">
			<div class="items_3">
				<div class="item">
					<div class="item_div1">
						<p>
							{{ sku[lang] }}
						</p>
					</div>
					<div class="item_div2">
						<div class="item_rate">
							<p>{{ sku.rate }}%</p>
							<p>{{ $t('utils.' + sku.unit + 'Income') }}</p>
						</div>
						<div class="item_day">
							<p>{{ sku.day }}{{ $t('utils.' + sku.unit) }}</p>
							<p>{{ $t('utils.cycle') }}</p>
						</div>
						<div class="item_min">
							<p>{{ utils_moneyMark() }}{{ sku.min }}</p>
							<p>{{ $t('utils.startingAmount') }}</p>
						</div>
					</div>
				</div>
			</div>
			<van-field v-model="number" type="number" :placeholder="$t('item.inputAmount')" />
		</van-dialog>
		<van-dialog v-model="show_tc" :confirmButtonText="$t('utils.confirm')">
			<div class="popup" v-html="tc_content"></div>
		</van-dialog>
		<div v-if="msg_show" class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="../images/index/kefu.png">
		</div> -->

		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import Api from "../../interface/index"

import {
	Swipe,
	SwipeItem,
	Icon,
	Progress,
	Dialog,
	Field
} from "vant";

Vue.use(Icon).use(Progress).use(Dialog).use(Field);

export default {
	name: "Index",
	components: {
		VanSwipe: Swipe,
		VanSwipeItem: SwipeItem,
	},
	data() {
		return {
			lang: "zh_hk", // 设置默认语言为日语
			msg_show: true,
			loading: false,
			kefuLoading: false, // 客服跳转loading状态
			icon: [],
			data: { item1: { show: true }, item2: { show: true }, item3: { show: true } },
			app: {},
			islogin: false,
			isapp: false,
			show_img: false,
			show_tz: false,
			show_tc: false,
			tc_content: "",
			number: '',
			sku: [],
			popupContent: '', // 公告内容
			projectList: [] // 项目列表，从接口获取
		};
	},
	created() {
		this.$parent.footer('index');

		// 确保语言值正确初始化
		const savedLang = localStorage.getItem('lang');
		if (savedLang) {
			this.$set(this, 'lang', savedLang);
			// 同步到VueI18n（使用前端语言代码）
			if (savedLang === 'en_us') {
				this.$i18n.locale = 'en';
			} else if (savedLang === 'ja_jp') {
				this.$i18n.locale = 'ja';
			} else if (savedLang === 'ko_kr') {
				this.$i18n.locale = 'ko';
			} else {
				this.$i18n.locale = savedLang; // zh_hk 保持不变
			}
		} else {
			// 设置默认语言为日语
			this.$set(this, 'lang', "zh_hk");
			this.$i18n.locale = "zh_hk";
			localStorage.setItem('lang', "zh_hk");
		}

		console.log('首页初始化，当前语言:', this.lang, 'VueI18n语言:', this.$i18n.locale);
		
		// 获取用户信息（如果已登录）
		this.getUserInfo();
	},
	computed: {
		cleanPopupContent() {
			if (!this.popupContent) return '';
			// 去除HTML标签，只保留纯文本
			return this.popupContent.replace(/<[^>]*>/g, '');
		},
		// 用于下拉选择器显示的语言代码（将后端语言代码转换为前端显示代码）
		displayLang: {
			get() {
				// 将后端语言代码转换为前端显示代码
				if (this.lang === 'en_us') return 'en';
				if (this.lang === 'ja_jp') return 'ja';
				if (this.lang === 'ko_kr') return 'ko';
				return this.lang; // zh_hk 保持不变
			},
			set(value) {
				// 将前端显示代码转换为后端语言代码
				if (value === 'en') {
					this.lang = 'en_us';
				} else if (value === 'ja') {
					this.lang = 'ja_jp';
				} else if (value === 'ko') {
					this.lang = 'ko_kr';
				} else {
					this.lang = value; // zh_hk 保持不变
				}
			}
		},
		// 检查用户是否已登录
		isUserLoggedIn() {
			return localStorage.getItem('token') != null;
		},
		// 检查用户是否在白名单中
		isUserWhitelisted() {
			const userInfo = this.$store.getters.getUserInfo;
			console.log('用户信息:', userInfo);
			console.log('检查用户白名单状态:', userInfo);
			return userInfo && userInfo.whitelist === 1;
		},
		// 检查是否显示贷款按钮（用户已登录且在白名单中）
		shouldShowLoanButton() {
			return this.isUserLoggedIn && this.isUserWhitelisted;
		}
	},
	watch: {
		lang: {
			handler(newVal, oldVal) {
				console.log('语言值变化:', oldVal, '->', newVal);
				// 确保选择器显示正确的值
				this.$nextTick(() => {
					const selectElement = document.querySelector('.language_select');
					if (selectElement) {
						selectElement.value = this.displayLang;
						console.log('watch中更新语言选择器值:', this.displayLang);
					}
				});
			},
			immediate: true
		}
	},
	mounted() {
		// 确保语言选择器正确显示
		this.$nextTick(() => {
			// 确保语言设置的优先级：localStorage > 默认繁体中文
			const savedLang = localStorage.getItem('lang');
			if (savedLang) {
				this.lang = savedLang;
				// 同步VueI18n语言
				if (savedLang === 'en_us') {
					this.$i18n.locale = 'en';
				} else if (savedLang === 'ja_jp') {
					this.$i18n.locale = 'ja';
				} else if (savedLang === 'ko_kr') {
					this.$i18n.locale = 'ko';
				} else {
					this.$i18n.locale = savedLang;
				}
			} else {
				// 如果没有保存的语言，设置默认日语
				this.lang = "zh_hk";
				this.$i18n.locale = "zh_hk";
				localStorage.setItem('lang', "zh_hk");
			}

			// 更新语言选择器显示
			const selectElement = document.querySelector('.language_select');
			if (selectElement) {
				selectElement.value = this.displayLang;
				console.log('mounted中设置语言选择器值:', this.displayLang, '当前语言:', this.lang);
			}
		});

		this.start();
		//代理标识设置
		if (this.$router.history.current.query.agent) {
			localStorage.setItem('agent', this.$router.history.current.query.agent);
		}
		//APP识别
		if (this.$router.history.current.query.isapp) {
			localStorage.setItem('isapp', 'true');
		}
		this.isapp = localStorage.getItem('isapp') != null;
		console.log();
		var that = this;
		document.body.addEventListener("scroll", function () {
			if (!that.show_kefu) {
				return;
			}
			that.show_kefu = false;
		}, false);
		document.addEventListener('click', function (ev) {
			if (ev.target.className != 'kefu_img') {
				that.show_kefu = false;
			}
		}, false);
	},
	methods: {
		download() {
			let downloadurl = document.createElement('A');
			downloadurl.href = this.app.app_link;
			downloadurl.target = "blank";
			downloadurl.click();

		},
		kefu_to() {
			// 直接跳转到客服，与用户中心保持一致
			this.jumpToCustomerService();
		},
		
		// 直接跳转到客服
		jumpToCustomerService() {
			// 防止重复点击
			if (this.kefuLoading) return;
			
			this.kefuLoading = true;
			console.log('直接跳转客服，获取配置...');
			
			let agent = localStorage.getItem('agent');
			Fetch('/index/webconfig', {agent, type: 'web'}).then(res => {
				if (res.data.kefu_link) {
					console.log('直接跳转到客服:', res.data.kefu_link);
					window.location.href = res.data.kefu_link;
				} else {
					this.$toast('客服配置错误');
				}
			}).catch(err => {
				console.error('获取客服配置失败:', err);
				this.$toast('客服暂时不可用，请稍后重试');
			}).finally(() => {
				this.kefuLoading = false;
			});
		},
		hideDown() {
			this.show_img = false;
			this.$store.commit('setShowAdvert', false);
		},
		start() {
			Fetch('/index/int', { lang: this.lang }).then((r) => {
				//打包web请注释掉版本更新这段代码
				//-----------------------------------------
				// if(window.plus){
				// let appVersion1 = plus.runtime.version;
				// let appVersion2 = r.data.version.app_version;
				// //版本号不同则更新APP
				// if(parseInt(appVersion1.split(".").join(""))<parseInt(appVersion1.split(".").join(""))){
				// 	this.$dialog.alert({
				// 	  title: 'APP更新',
				// 	  message: r.data.version.app_instructions,
				// 	}).then(() => {
				// 		let u = navigator.userAgent;
				// 		let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
				// 		let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				// 		if (isAndroid) {
				// 		 // alert("我是安卓");
				// 			window.location.href = r.data.version.android_app_down_url;
				// 		}
				// 		if (isIOS) {
				// 		 // alert("我是苹果");
				// 		 window.location.href = r.data.version.ios_app_down_url;
				// 		}
				// 	});
				// }
				// }
				//-----------------------------------------
				this.data = r.data;
				console.log(this.data);
				this.loading = true;

				// 设置公告内容
				if (r.data.popup && r.data.popup.content) {
					this.popupContent = r.data.popup.content;
				}

				// 设置项目列表数据
				if (r.data.cats && r.data.cats.length > 0) {
					this.projectList = r.data.cats.map(cat => ({
						id: cat.id,
						name: this.getProjectName(cat), // 使用专门的方法获取项目名称
						img: cat.img,
						rates: this.parseRateList(cat.rateList), // 解析利率列表
						company: cat.note || this.$t('index.title'), // 使用 note 作为公司名称，如果没有则使用默认值
						route: '/allProducts' // 统一跳转到项目详情页
					}));
				}

				if (r.data.popup.show == 1) {
					this.tc_content = r.data.popup.content;
					if (localStorage.getItem('tc') != this.tc_content) {
						localStorage.setItem('tc', this.tc_content);
						this.show_tc = true;
					}
				}
				
				// 数据获取完成后，只更新页面标题
				document.title = 'Ant Financial';
			});
			// 移除重复的webconfig调用，使用App.vue中已加载的数据
			this.app = this.$parent.app || {};
			this.islogin = localStorage.getItem('token') != null;
		},
		onChange(index) {
			let els = this.$refs.dian.querySelectorAll("div");
			for (let i = 0; i < els.length; i++) {
				els[i].className = "";
			}
			els[index].className = "selected";
		},
		buy(item) {
			this.sku = item;
			this.show_tz = true;
		},
		confirm() {
			if (!this.number) {
				this.$toast(this.$t('item.inputAmount'));
				return false;
			}
			Fetch("/index/item_apply", {
				id: this.sku.id,
				money: this.number
			}).then(r => {
				this.$router.push("/order");
			}).catch(err => {
				this.psd_val = '';
			})
		},
		onLanguageChange() {
			console.log('语言切换:', this.displayLang, '->', this.lang); // 添加调试日志

			// 更新VueI18n的语言（使用前端语言代码）
			this.$i18n.locale = this.displayLang;

			// 保存到localStorage（使用后端语言代码）
			localStorage.setItem('lang', this.lang);

			// 确保选择器显示正确的值
			this.$nextTick(() => {
				const selectElement = document.querySelector('.language_select');
				if (selectElement) {
					selectElement.value = this.displayLang;
					console.log('语言选择器已更新为:', this.displayLang);
				}
			});

			// 语言切换后，重新发起请求获取对应语言的数据
			this.start();
		},

		// 跳转到项目页面
		goToProject(project) {
			console.log('跳转到项目:', project);
			// this.$router.push(project.route);
			this.$router.push({
				path: "/allProducts",
				query: {
					id: project.id
				}
			});
		},

		// 获取项目名称，处理不同语言的数据格式
		getProjectName(project) {
			// 首先尝试使用当前语言
			if (project[this.lang]) {
				return project[this.lang];
			}
			
			// 如果当前语言没有，尝试使用对应的后端语言代码
			let backendLang = this.lang;
			if (this.lang === 'en') {
				backendLang = 'en_us';
			} else if (this.lang === 'ja') {
				backendLang = 'ja_jp';
			} else if (this.lang === 'ko') {
				backendLang = 'ko_kr';
			}
			
			if (project[backendLang]) {
				return project[backendLang];
			}
			
			// 如果都没有，使用英文作为兜底
			if (project.en_us) {
				return project.en_us;
			}
			
			// 最后使用中文作为兜底
			return project.zh_hk || project.name || '未知項目';
		},

		// 解析利率列表
		parseRateList(rateList) {
			if (!rateList) return [];

			// 如果rateList是字符串，尝试解析
			if (typeof rateList === 'string') {
				try {
					// 尝试解析JSON格式
					const parsed = JSON.parse(rateList);
					if (Array.isArray(parsed)) {
						return parsed;
					}
				} catch (e) {
					// 如果不是JSON，尝试按逗号分割
					if (rateList.includes(',')) {
						return rateList.split(',').map(rate => rate.trim());
					}
					// 单个值
					return [rateList];
				}
			}

			// 如果已经是数组，直接返回
			if (Array.isArray(rateList)) {
				return rateList;
			}

			return [];
		},

		// 获取用户信息
		async getUserInfo() {
			try {
				// 检查是否有token，没有token则不请求用户信息
				const token = localStorage.getItem('token');
				if (!token) {
					console.log('首页：没有token，用户未登录');
					return;
				}
				
				console.log('首页：开始获取用户信息...');
				
				// 调用API获取用户信息
				const result = await Fetch('/user/info');
				
				console.log('首页：用户信息API响应:', result);
				
				if (result && result.code === 1) {
					console.log('首页：用户信息获取成功:', result.data);
					// 将用户信息保存到全局store中
					this.$store.commit('setUserInfo', result.data);
				} else {
					console.log('首页：用户信息获取失败或业务提示:', result);
				}
			} catch (error) {
				console.error('首页：获取用户信息出错:', error);
			}
		},

	}
};
</script>

<style lang="less" scoped>
/deep/ .van-cell {
	padding: 15px 26px;
}

.home_wrap {
	width: 100%;
	// min-height: 100vh;
	// background-color: #F6F6F6;
	background-color: #fff;
}

.content {
	width: 100%;
	background-color: #fff;
	padding: 10px;
	box-sizing: border-box;
}

.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;

	.language {
		position: absolute;
		top: 4px;
		right: 0;
		height: 36px;

		img {
			height: 100%;
		}
	}

	.msg {
		position: absolute;
		top: 9px;
		right: 6px;
		height: 23px;

		img {
			height: 100%;
		}
	}

	.top_title {
		text-align: center;
		font-size: 16px;
		display: block;
		height: 44px;
		line-height: 44px;
		color: #323233
	}

	/* 新的语言选择下拉框样式 */
	.language_selector {
		position: absolute;
		top: 10px;
		right: 10px;
		height: 36px;
		z-index: 1001;
		font-size: 14px;
		color: #000;
	}
}

.langbar {
	position: relative;
	margin-top: 44px;
	padding-top: 8px;
	height: 56px;
	background-color: #fff;

}

// 消息通知横幅
.message_banner {
	background: #FFFBE8;
	height: 40px;
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 0 15px;
	width: 100%;
	box-sizing: border-box;
	overflow: hidden;

	img {
		width: 16px;
		height: 16px;
		flex-shrink: 0;
	}

	.message_scroll {
		flex: 1;
		overflow: hidden;
		position: relative;
	}

	.message_text {
		font-size: 14px;
		color: #ED6A0C;
		line-height: 1.4;
		white-space: nowrap;
		display: inline-block;
		animation: scrollText 20s linear infinite;
		animation-delay: 2s;
	}
}

@keyframes scrollText {
	0% {
		transform: translateX(100%);
	}

	100% {
		transform: translateX(-100%);
	}
}

.search_box {
	width: 90%;
	height: 32px;
	background-color: #f6f6f6;
	border-radius: 17px;
	border: solid 1px #1989fa;
	margin: 8px auto;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding: 0 10px 0 14px;

	.fdj {
		width: 16px;
		height: 16px;
		background: url(../images/item/fdj.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.search_inp {
		flex: 1;
		margin: 0 8px;
		font-size: 14px;
		color: #000000;
		line-height: 20px;
		height: 20px;
	}

	.clear_inp {
		width: 20px;
		height: 20px;
		background: url(../images/item/clear.png) no-repeat center center;
		background-size: 100% 100%;
	}
}

.swiper-container {
	width: 100%;
	height: 200px;
	background: #FFFFFF;
	position: relative;

	.van-swipe-item {
		overflow: hidden;
	}

	a {
		display: block;
		width: 100%;
		height: 100%;
	}

	img {
		border-radius: 6px;
		height: 100%;
		width: 100%;
		object-fit: cover;
		object-position: center;
	}

	// 轮播图指示器样式
	.custom-indicator {
		position: absolute;
		bottom: 15px;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		gap: 8px;
		z-index: 10;

		div {
			width: 6px;
			height: 6px;
			background: #EBEDF050;
			border-radius: 50%;
			transition: all 0.3s ease;

			&.selected {
				background: #fff;
			}
		}
	}
}

.work_box {
	background: #FFFFFF;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	border-radius: 16px;
	margin: 8px 8px;
	padding-top: 20px;

	.item {
		width: 20%;
		text-align: center;
		margin-bottom: 10px;

		.item_img {
			width: 100%;
			border-radius: 5px;
			overflow: hidden;

			img {
				width: 32px;
				height: 32px;
			}
		}

		.item_title {
			width: 100%;
			line-height: 12px;
			font-size: 14px;
			color: #555;
			text-align: center;
			transform: scale(0.85);
		}
	}
}

.work_box.query {
	.item {

		.item_img {
			border-radius: 5px;
			background: #f0f0f0;
		}

		.item_title {
			width: 100%;
			height: 14px;
			margin-left: 0;
			background: #f0f0f0;
		}
	}

}

/* 稳健项目投资产品展示样式 */
.stable_projects {
	background: #FFFFFF;
	border-radius: 16px;
}

.projects_header {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	position: relative;
	margin-top: 20px;
}

.blue_bar {
	width: 4px;
	height: 16px;
	background: #1989fa;
	margin-right: 12px;
}

.projects_title {
	font-size: 14px;
	color: #000;
	margin: 0;
	flex: 1;
}

.company_logo {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

.project_cards {
	display: flex;
	flex-direction: column;
	gap: 16px;
	// padding-bottom: 20px;
}

.project_card {
	display: flex;
	align-items: center;
	background: #FFFFFF;
	border-radius: 12px;
	padding: 16px;
	gap: 16px;
}

.card_image {
	width: 120px; // 稍微减小图片宽度
	height: 80px; // 相应调整高度
	margin-right: 0; // 移除margin，使用gap
	flex-shrink: 0;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 8px;
	}
}

.card_content {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 70px;
	align-self: center;
	// overflow: hidden; 
}

.project_name {
	font-size: 16px;
	color: #555;
	margin: 0 0 8px 0;
}

.rates {
	display: flex;
	gap: 8px; // 减小间距
	margin-bottom: 8px;
	max-width: 100%;
	overflow-x: auto;

	// 隐藏滚动条但保持滚动功能
	&::-webkit-scrollbar {
		height: 3px; // 减小滚动条高度
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 2px;
	}

	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 2px;

		&:hover {
			background: #a8a8a8;
		}
	}

	// 限制rate元素宽度，确保最多显示3个
	.rate {
		font-size: 13px; // 稍微减小字体
		font-weight: 600;
		color: #ff4d4f;
		background: transparent;
		padding: 2px 6px; // 添加内边距
		border-radius: 4px; // 添加圆角
		flex-shrink: 0; // 防止收缩
		min-width: 35px; // 设置最小宽度
		text-align: center;
		white-space: nowrap; // 防止文字换行
		// border: 1px solid #ff4d4f; // 添加边框
		padding-bottom: 10px;
	}
}

.company_name {
	font-size: 14px;
	color: #969799;
	margin: 0;
}

.ads_box_1 {
	border-radius: 13px;
	margin-top: 10px;
	text-align: center;

	img {
		width: 95%;
	}
}

.ads_box {
	// background: rgba(255, 255, 255, 1);
	width: 97%;
	border-radius: 13px;
	margin: 10px auto 0 auto;
	display: flex;
	text-align: center;

	.ads_img {}

	img {
		width: 96%;
		border-radius: 5px;
	}
}

.items_1,
.items_2,
.items_3 {
	margin: 10px 2% 0 2%;
	width: 96%;

	.items_tit {
		overflow: hidden;
		border-radius: 5px 5px 0 0;
		height: 44px;
		line-height: 44px;
		font-size: 16px;
		color: rgba(0, 0, 0, .8);
		background: #FFFFFF;
		border-bottom: 1px solid #F7F7F7;
		padding: 0 14px;
		display: flex;
		justify-content: space-between;

		.tit_tip {
			display: contents;
			font-size: 12px;
			font-weight: normal;
			color: #b2b2b2;
			margin-left: 10px;
		}

		.tit_more {
			font-size: 12px;
			font-weight: normal;
			color: #b2b2b2;

		}
	}

	.item {
		background: #FFFFFF;
	}
}

.items_1 {
	.item {
		padding: 5px;
		margin: 0 0 10px 0;

		div {
			margin: 20px 0;
		}

		.item_tit {
			text-align: center;
			overflow: hidden;

			p {
				text-overflow: ellipsis;
				white-space: nowrap;
				font-weight: bold;
				font-size: 16px;
			}
		}

		.item_rate {
			text-align: center;
			color: #FF0000;
			font-size: 22px;
			font-weight: bold;
		}

		.item_desc {
			display: flex;

			p {
				width: 50%;
				text-align: center;
			}
		}

		.item_btn {
			text-align: center;

			button {
				margin: auto;
				width: 60%;
				min-width: 60px;
				background: #e7544d;
				color: #FFFFFF;
				padding: 10px 0px;
				border-radius: 10px;
			}

			.item_btn_over {
				background: #999;
			}
		}
	}
}

.items_2 {
	.item {
		display: flex;
		width: 100%;
		text-align: center;
		border-bottom: 1px solid #ECECEC;

		div {
			margin: 15px 0;
		}

		.item_rate {
			width: 20%;

			p {
				padding: 5px 0;
			}

			p:nth-child(1) {
				font-weight: bold;
				font-size: 14px;
				color: #FF0000;

			}

			p:nth-child(2) {
				color: #999;
			}
		}

		.item_tit {
			width: 55%;

			p {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				padding: 5px 0;
			}

			p:nth-child(1) {
				font-weight: bold;
			}

			p:nth-child(2) {
				color: #999;
			}
		}

		.item_btn {
			width: 25%;

			button {
				min-width: 60px;
				margin-top: 12px;
				color: #1989fa;
				padding: 5px 5px;
				border-radius: 5px;
				border: 1px solid #1989fa;
			}

			.item_btn_over {
				color: #999;
				border: 1px solid #999;
			}
		}
	}
}

.items_3 {
	.item {
		margin-bottom: 10px;

		div {
			margin: 5px 0;
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			border-bottom: 1px solid #ECECEC;
			padding: 15px 10px;

			p:nth-child(1) {
				// width: 70%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

			}

			p:nth-child(2) {
				color: #999;
			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			font-size: 14px;

			div {
				width: 33.33%;

				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					color: #FF0000;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				p:nth-child(1) {
					font-weight: bold;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				p:nth-child(1) {
					font-weight: bold;

				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}

		.item_div3 {
			color: #999;
			padding: 5px 10px;
		}

		.item_div4 {
			padding: 5px 10px;
			display: flex;
			justify-content: space-between;

			div:nth-child(1) {
				width: 75%;
				margin-top: 16px;
			}

			.item_btn {
				width: 20%;

				button {
					min-width: 60px;
					color: #1989fa;
					padding: 5px 5px;
					border-radius: 5px;
					border: 1px solid #1989fa;
				}

				.item_btn_over {
					color: #999;
					border: 1px solid #999;
				}
			}
		}
	}
}

.popup {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	flex: 1;
	max-height: 60vh;
	padding: 26px 24px;
	overflow-y: auto;
	font-size: 14px;
	line-height: 20px;
}

/* 修改未高亮的小圆点颜色 */
.van-swipe__indicator {
	background-color: rgba(255, 255, 255, 0.4) !important;
	/* 比如半透明白色 */
}

/* 修改高亮的小圆点颜色 */
.van-swipe__indicator--active {
	background-color: #ff4d4f !important;
	/* 比如亮红色 */
}
</style>
